/**
 * Same-origin fetch with Clerk Bearer token.
 *
 * After skipping clerkMiddleware handshake on /projects (and related app
 * document routes), session cookies alone are often incomplete. API routes
 * that call auth() need Authorization: Bearer — same pattern as tRPC.
 */
export async function clerkAuthenticatedFetch(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  const headers = new Headers(init?.headers);

  try {
    const getToken =
      typeof window !== "undefined"
        ? (
            window as unknown as {
              Clerk?: {
                session?: {
                  getToken: (opts?: {
                    template?: string;
                  }) => Promise<string | null>;
                };
              };
            }
          ).Clerk?.session?.getToken
        : undefined;

    if (getToken) {
      const token = await Promise.race([
        getToken(),
        new Promise<null>((resolve) => setTimeout(() => resolve(null), 2500)),
      ]);
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
    }
  } catch {
    // cookies may still authenticate when the handshake completed
  }

  return fetch(input, {
    ...init,
    headers,
    credentials: init?.credentials ?? "include",
  });
}
